export default "#!/bin/bash\n\ncat 00-entrypoint.md\n\n# Remove myself\nif [ -f /mnt/init ]; then\n    rm /mnt/init;\nfi\n\nexec /bin/sh";